import { cn } from './cn';

export type SignalsTooltipLabelSignal = {
  bucketName: string;
  reason: string | null;
  isIgnored?: boolean;
};

export type SignalsTooltipLabelProps = {
  signals: SignalsTooltipLabelSignal[];
};

export function SignalsTooltipLabel({ signals }: SignalsTooltipLabelProps) {
  return (
    <div className="flex flex-col gap-1 text-sm">
      <div className="font-medium">Triggered signals</div>
      {signals.map((s, i) => (
        <div key={`${s.bucketName}-${i}`} className={cn(s.isIgnored && 'opacity-60')}>
          <span className={cn('font-medium', s.isIgnored && 'line-through')}>{s.bucketName}</span>
          {s.isIgnored && <span className="ml-1 text-xs italic">(ignored)</span>}
          {s.reason != null && s.reason.length > 0 && (
            <>
              {' — '}
              <span className="opacity-80">{s.reason}</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
